/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * News list component
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.0
 */

import { FC, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { IRouteParams } from '@/main/routes/constants/routesConstants';

import { makeSelectAuthoritiesIsNewsServiceUser } from '../../PageAuth/selectors/authSelectors';
import { useSendNewsListViewedMutation } from '../store';
import { NewsListContainerStyled, NewsListWrapperStyled } from '../styled/NewsListStyled';
import { INewsListItem } from '../types';
import NewsListItem from './NewsListItem';

interface INewsListProps {
    news?: INewsListItem[];
}

const NewsList: FC<INewsListProps> = ({ news }) => {
    const { newsId } = useParams<IRouteParams>();

    const isNewsServiceUser = useSelector(makeSelectAuthoritiesIsNewsServiceUser());

    const [sendNewsListViewed] = useSendNewsListViewedMutation();

    useEffect(() => {
        if (news && news.length && !isNewsServiceUser) {
            sendNewsListViewed();
        }
    }, [isNewsServiceUser, news, sendNewsListViewed]);

    if (!news || !news.length) return <NewsListContainerStyled />;

    return (
        <NewsListContainerStyled>
            <NewsListWrapperStyled>
                {news.map((el) => (
                    <NewsListItem itemData={el} key={el.id} selected={newsId === String(el.id)} />
                ))}
            </NewsListWrapperStyled>
        </NewsListContainerStyled>
    );
};

export default NewsList;
